import { renderPdfDirect } from "../../api/reportTicket";

const isNative = () => {
  try {
    return window.Capacitor?.isNativePlatform?.() === true;
  } catch {
    return false;
  }
};

const toB64 = (blob) =>
  new Promise((res, rej) => {
    const r = new FileReader();
    r.onloadend = () => res(String(r.result).split(",")[1]);
    r.onerror = rej;
    r.readAsDataURL(blob);
  });

const webDownload = (blob, name) => {
  const u = URL.createObjectURL(blob);
  const a = Object.assign(document.createElement("a"), { href: u, download: name });
  document.body.appendChild(a);
  a.click();
  setTimeout(() => { a.remove(); URL.revokeObjectURL(u); }, 4000);
};

const saveNative = async (blob, name, dir) => {
  const { Filesystem, Directory } = await import("@capacitor/filesystem");
  return Filesystem.writeFile({ path: name, data: await toB64(blob), directory: Directory[dir] });
};

export const copyLink = async (url) => {
  if (!url) return false;
  try { await navigator.clipboard.writeText(url); return true; } catch { /* fallback */ }
  try {
    const ta = document.createElement("textarea");
    ta.value = url;
    ta.style.cssText = "position:fixed;opacity:0";
    document.body.appendChild(ta);
    ta.focus();
    ta.setSelectionRange(0, url.length);
    document.execCommand("copy");
    ta.remove();
    return true;
  } catch {
    return false;
  }
};

export const sharePdf = async (html, shareUrl, name, onReady) => {
  if (!html) return;
  const safe = name.replace(/[\\/:*?"<>|]+/g, " ").replace(/\s+/g, " ").trim() || "report.pdf";
  try {
    const blob = await renderPdfDirect(html, name.replace(/\.pdf$/i, ""));
    onReady?.();
    if (isNative()) {
      const w = await saveNative(blob, safe, "Cache");
      const { Share } = await import("@capacitor/share");
      // نُرمّز الـURI (مسافات/حروف عربية) ليصبح نصّ URL صالحاً على iOS، فلا يَفسد الاسم عند المشاركة.
      const uri = /[^\x00-\x7F]|\s/.test(w.uri) ? encodeURI(w.uri) : w.uri;
      await Share.share({ files: [uri] });
      return;
    }
    const file = new File([blob], safe, { type: "application/pdf" });
    if (navigator.canShare?.({ files: [file] })) {
      await navigator.share({ files: [file] });
    } else if (navigator.share && shareUrl) {
      await navigator.share({ url: shareUrl });
    } else {
      webDownload(blob, safe);
    }
  } catch {
    if (shareUrl) await copyLink(shareUrl);
  }
};
